import { useNavigate } from 'react-router-dom';
import { themeClasses } from '@member-portal/ui';

function SplitLandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col fhxd-chrome-top">
      {/* Split Container */}
      <div className="flex-1 flex flex-col md:flex-row">
        {/* Partner Side */}
        <div
          className="relative overflow-hidden cursor-pointer flex-1"
          onClick={() => navigate('/for-partners')}
        >
          {/* Image Container - square on mobile, flexible height on desktop */}
          <div className="relative aspect-square md:aspect-auto md:h-full w-full">
            {/* Background Image */}
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: 'url(/images/images/INSIDER.jpg)',
              }}
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-black opacity-50" />
            {/* Content */}
            <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
              <p className={`${themeClasses.text.body} text-white/90 uppercase tracking-[0.3em] mb-4 text-sm`}>
                FOR PARTNERS
              </p>
              <h2 className={`${themeClasses.title.h3} text-white mb-4`}>
                Access a new community of travel advisors and affluent consumers
              </h2>
              <p className={`${themeClasses.text.body} text-white/90 mb-6 text-base`}>
                Reach an Untapped, Targeted Audience
              </p>
              <button
                className={`px-6 py-3 bg-white text-black ${themeClasses.text.button}
                  hover:bg-white/90 transition-all duration-300`}
              >
                Partner Opportunities
              </button>
            </div>
          </div>
        </div>

        {/* Advisor Side */}
        <div
          className="relative overflow-hidden cursor-pointer flex-1"
          onClick={() => navigate('/for-advisors')}
        >
          {/* Image Container - square on mobile, flexible height on desktop */}
          <div className="relative aspect-square md:aspect-auto md:h-full w-full">
            {/* Background Image */}
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: 'url(/images/images/sara-dubler-Koei_7yYtIo-unsplash.jpg)',
              }}
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-black opacity-50" />
            {/* Content */}
            <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
              <p className={`${themeClasses.text.body} text-white/90 uppercase tracking-[0.3em] mb-4 text-sm`}>
                FOR ADVISORS
              </p>
              <h2 className={`${themeClasses.title.h3} text-white mb-4`}>
                Discover a curated partner collection designed for travel advisors
              </h2>
              <p className={`${themeClasses.text.body} text-white/90 mb-6 text-base`}>
                Earn More, Faster
              </p>
              <button
                className={`px-6 py-3 bg-white text-black ${themeClasses.text.button}
                  hover:bg-white/90 transition-all duration-300`}
              >
                Advisor Opportunities
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SplitLandingPage;
